import { makeRequest } from "../lib/makeRequest";

export const inventory_target_overall_v4 = (data) =>
  makeRequest("/target-inventories/overall", {
    fromMonth: data.from_month,
    fromYear: data.from_year,
    toMonth: data.to_month,
    toYear: data.to_year,
  });

export const inventory_target_cluster_v4 = (data) =>
  makeRequest(`/target-inventories/cluster/${data.clusterId}`, {
    fromMonth: data.from_month,
    fromYear: data.from_year,
    toMonth: data.to_month,
    toYear: data.to_year,
  });

export const inventory_target_area_v4 = (data) =>
  makeRequest(`/target-inventories/area/${data.areaId}`, {
    fromMonth: data.from_month,
    fromYear: data.from_year,
    toMonth: data.to_month,
    toYear: data.to_year,
  });

export const inventory_target_branch_v4 = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("fromMonth", data.from_month);
  urlParams.append("fromYear", data.from_year);
  urlParams.append("toMonth", data.to_month);
  urlParams.append("toYear", data.to_year);
  return makeRequest(
    `/target-inventories/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
